interface ProductSkeletonProps {
  count?: number;
  showTitle?: boolean;
}

export function ProductSkeleton({
  count = 4,
  showTitle = true,
}: ProductSkeletonProps) {
  return (
    <div className="py-8">
      {/* Título del carousel skeleton */}
      {showTitle && (
        <div className="mb-6">
          <div className="h-8 md:h-10 bg-gray-200 rounded-lg w-48 md:w-64 animate-pulse" />
          <div className="h-4 bg-gray-200 rounded w-32 md:w-40 mt-2 animate-pulse" />
        </div>
      )}

      {/* Grid de productos skeleton */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-6">
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden"
          >
            {/* Imagen skeleton */}
            <div className="aspect-square bg-gray-200 animate-pulse" />

            {/* Contenido skeleton */}
            <div className="p-3 md:p-4 space-y-3">
              {/* Título del producto */}
              <div className="h-4 bg-gray-200 rounded animate-pulse" />
              <div className="h-3 bg-gray-200 rounded w-3/4 animate-pulse" />

              {/* Selector de cantidad skeleton */}
              <div className="flex items-center justify-center space-x-2">
                {/* Botón menos */}
                <div className="w-8 h-8 bg-gray-200 rounded-full animate-pulse" />

                {/* Input de cantidad */}
                <div className="w-12 h-8 bg-white border border-gray-200 rounded animate-pulse" />

                {/* Botón más */}
                <div className="w-8 h-8 bg-gray-200 rounded-full animate-pulse" />
              </div>

              {/* Botón AGREGAR skeleton */}
              <div className="h-10 bg-blue-600/20 rounded-lg animate-pulse" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
